import { useEffect } from 'react';

import { isLeavingForOtherTab } from '~/services/screenTab/screenTabLock';

export function useDataCollector(collector: IDataCollector, displayPopup: boolean, dependencies: unknown[] = []) {
    // La raison d'arrêt alimente `health.endReason` (boîte noire). `beforeunload` = onglet
    // fermé ou rechargé (best effort : l'écriture Firestore peut ne pas partir — c'est
    // précisément l'absence de raison qui signale une fin brutale à la lecture).
    const onBeforeUnload = (e: any) => {
        // Mise en veille parce que le bar est ouvert dans un autre onglet : départ voulu,
        // pas de « Quitter le site ? » (il annulerait la veille) et raison distincte.
        if (isLeavingForOtherTab()) {
            collector.stop('other_tab');
            return;
        }
        if (displayPopup) {
            e.preventDefault();
            e.returnValue = '';
        }
        collector.stop('page_unload');
    };
    const onLocationChange = () => collector.stop('navigation');

    useEffect(() => {
        collector.start();
        window.addEventListener('beforeunload', onBeforeUnload);
        window.addEventListener('locationchange', onLocationChange);

        return () => {
            // Cleanup React = retour au menu, changement de jeu (deps) ou démontage écran.
            collector.stop('unmount');
            window.removeEventListener('beforeunload', onBeforeUnload);
            window.removeEventListener('locationchange', onLocationChange);
        };
    }, dependencies);
}
